import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/trading/calling-tokens.md?raw';

const TradingCallingTokens: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default TradingCallingTokens;
